export default __webpack_public_path__ + "static/media/PAPA.9e87bea0.png";